import AdditionalInfo from "../common/additionalInfo/additionalInfo";

export default function DisabledServicesWarning() {
  return (
    <AdditionalInfo
      variant="warning"
      text="Some services require different providers and can't be booked in the same visit. Please book separate appointments if necessary."
      sx={{
        mt: 0,
        mb: 2,
      }}
    />
  );
}
